import { SET_CATEGORIES, SET_CATEGORY_DATA_LOADING, SET_SEARCH_CATEGORY_BY_ID } from '../actions/types';

const initialState = {
  isLoading: false,
  categoriesData: [],
  searchByIdCategoryData: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_CATEGORY_DATA_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case SET_CATEGORIES:
      return {
        ...state,
        categoriesData: payload,
        isLoading: false,
      };
    case SET_SEARCH_CATEGORY_BY_ID:
      return {
        ...state,
        searchByIdCategoryData: payload,
        isLoading: false,
      }
    default:
      return state;
  }
}
